<template>
  <Dropdown

    :trigger-style="`${selectedFilter || selectedUrgentOrderFilter || customFilter.length ? '!bg-[#38aa90bb] text-white !border-[#38aa90bb] !hover:bg-[#38aa90bb]' : ''} text-sm px-2 py-2 h-max font-medium text-[#282727] border-[1px] border-[#ACACAC] bg-white rounded-[10px] w-max  hover:bg-gray-100`"
    :close-on-outside-click="true"
  >
    <template #trigger>
      <button class="flex items-center justify-between gap-3">
        <span class="flex gap-1 items-center justify-between">
          <FunnelIcon class="size-5" />
          Filter
        </span>
        <span
          class="bg-transparent"

          v-if="
            selectedFilter || selectedUrgentOrderFilter || customFilter.length
          "
          @click.stop="clearFilters"
        >
          <XMarkIcon class="size-4" />
        </span>
      </button>
    </template>
    <template #contents>
      <div
        class="px-4 py-3 min-h-[100px] rounded-lg shadow-xl flex flex-col gap-4 w-full max-w-[35vw]"
        :class="props.currentMode == 'calendar' ? 'min-w-[35vw]' : ''"
      >
        <div class="flex w-full justify-between items-center gap-2">
          <h3 class="text-md font-semibold text-black outline-none">Filters</h3>
          <button
            class="bg-transparent text-gray-400 text-sm outline-none"
            v-if="selectedFilter"
            @click.stop="clearFilters"
          >
            Clear
          </button>
        </div>
        <div class="flex flex-col gap-2 w-full presets items-start">
          <template v-if="filterPresets.length">
            <h3 class="bg-transparent text-gray-400 text-sm outline-none">
              Quick Filters
            </h3>
            <div class="flex gap-2 items-center w-full flex-wrap">
              <label
                :for="`${filter}_${filterIndex}`"
                class="px-2 py-1 border-[1px] border-gray-400 rounded-[20px] flex gap-1 items-center cursor-pointer"
                v-for="(filter, filterIndex) in filterPresets"
                :key="filterIndex"
              >
                <input
                  type="radio"
                  class="hidden"
                  :id="`${filter}_${filterIndex}`"
                  :value="filter.value"
                  :name="filter.key"
                  :checked="filter.value == selectedFilter"
                  @input="
                    (e: any) => {
                      getQuickFilterData(e.target.value);
                    }
                  "
                />
                <label :for="`${filter}_${filterIndex}`">
                  <CheckIcon
                    class="size-4 border-[1px] border-gray-400 rounded-full text-gray-400"
                  />
                </label>

                <span
                  class="text-sm whitespace-nowrap"
                  v-html="filter.label"
                ></span>
              </label>

              <template v-if="props.currentMode !== 'calendar'">
                <label
                  :for="`${urgentFilter.key}_${urgentIndex}`"
                  class="px-2 py-1 border-[1px] border-gray-400 rounded-[20px] flex gap-1 items-center cursor-pointer"
                  v-for="(urgentFilter, urgentIndex) in filterUrgentOrders"
                  :key="urgentIndex"
                >
                  <input
                    type="radio"
                    class="hidden"
                    :id="`${urgentFilter.key}_${urgentIndex}`"
                    :value="urgentFilter.value"
                    :name="urgentFilter.key"
                    :checked="urgentFilter.value == selectedUrgentOrderFilter"
                    @input="
                      (e: any) => {
                        e.stopPropagation();
                        getUrgentOrderFilters(e.target.value);
                      }
                    "
                  />
                  <label :for="`${urgentFilter}_${urgentIndex}`">
                    <CheckIcon
                      class="size-4 border-[1px] border-gray-400 rounded-full text-gray-400"
                    />
                  </label>
                  <span
                    class="text-sm whitespace-nowrap"
                    v-html="urgentFilter.label"
                  ></span>
                </label>
              </template>
            </div>
           
          </template>
          <template v-if="customFilter.length > 0">
            <h3 class="bg-transparent text-gray-400 text-sm outline-none mt-4">
              All Filters
            </h3>
            <div class="flex gap-2 items-start w-full flex-col">
              <template
                v-for="(filter, filterIndex) in customFilter"
                :key="filterIndex"
              >
                <div class="flex gap-2 items-center w-full">
                  <Select
                    :options="
                      computedFilterList.filter(
                        (filter) => !selectedAllFilter.includes(filter.label),
                      )
                    "
                    track-by="key"
                    label="label"
                    class="min-w-[150px]"
                    v-model="selectedAllFilter[filterIndex]"
                    append-to-body
                    @option:selected="
                      (option: CustomFilter) =>
                        (customFilter[filterIndex] = option)
                    "
                    :clearable="false"
                    style="width: fit-content"
                  />
                  <template v-if="filter.type === 'multi-select'">
                    <Select
                      :options="filter.options"
                      track-by="key"
                      label="label"
                      append-to-body
                      v-model="filter.value"
                      class="flex-1"
                      multiple
                    />
                  </template>
                  <template v-if="filter.type === 'single-select'">
                    <Select
                      :options="filter.options"
                      track-by="key"
                      label="label"
                      append-to-body
                      v-model="filter.value"
                      class="flex-1"
                    />
                  </template>

                  <template v-if="filter.type === 'autocomplete'">
                    <Select
                      :options="filter.options"
                      track-by="value"
                      label="label"
                      append-to-body
                      v-model="filter.value"
                      class="flex-1"
                      :filterable="false"
                      :clearable="true"
                      @search="
                        async (e: string, loading: any) => {
                          loading(true);
                          await fetchCustomers(e);
                          loading(false);
                        }
                      "
                      :multiple="true"
                    />
                  </template>

                  <template v-if="filter.type === 'string'">
                    <input
                      type="text"
                      v-model="filter.value"
                      class="flex-1 outline-none border-[1px] border-gray-400 rounded-[4px] px-2 py-[3px] focus:outline-none focus:ring focus:ring-[#00b08760] duration-300 focus:border-[#00b08760]"
                    />
                  </template>
                  <template v-if="filter.type === 'date'">
                    <input
                      type="date"
                      v-model="filter.value"
                      class="flex-1 outline-none border-[1px] border-gray-400 rounded-[4px] px-2 py-[3px] focus:outline-none focus:ring focus:ring-[#00b08760] duration-300 focus:border-[#00b08760]"
                    />
                  </template>
                  <template
                    v-if="
                      filter.type === 'date-range' &&
                      typeof filter.value !== 'string' &&
                      !isArray(filter.value)
                    "
                  >
                    <input
                      type="date"
                      placeholder="From Date"
                      v-model="filter.value.from"
                      class="flex-1 outline-none border-[1px] border-gray-400 rounded-[4px] px-2 py-[3px] focus:outline-none focus:ring focus:ring-[#00b08760] duration-300 focus:border-[#00b08760]"
                    />
                    <input
                      type="date"
                      placeholder="To date"
                      v-model="filter.value.to"
                      class="flex-1 outline-none border-[1px] border-gray-400 rounded-[4px] px-2 py-[3px] focus:outline-none focus:ring focus:ring-[#00b08760] duration-300 focus:border-[#00b08760]"
                    />
                  </template>
                  <button @click="removeFilter(filterIndex)">
                    <XMarkIcon class="size-4" />
                  </button>
                </div>
              </template>
            </div>
          </template>
        </div>

        <Dropdown
          trigger-style="text-sm px-2 py-2 h-max font-medium text-[#282727] border-[1px] border-[#ACACAC] bg-white rounded-[10px] w-max hover:bg-gray-100"
          :close-on-outside-click="true"
          :close-on-select="true"
          v-if="computedFilterList.length"
        >
          <template #trigger>
            <span class="flex items-center justify-between gap-3">
              <span class="flex gap-1 items-center justify-between">
                <PlusIcon class="size-5" />
                Add Filter
              </span>
              <span class="bg-transparent">
                <ChevronDownIcon class="size-4" />
              </span>
            </span>
          </template>

          <template #contents>
            <ul>
              <li
                class="px-2 py-2 text-[#292D32] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-between gap-2"
                v-for="(filter, filterIndex) in computedFilterList"
                @click="addFilter(filter)"
                :key="filterIndex"
              >
                {{ filter.label }}
              </li>
            </ul>
          </template>
        </Dropdown>
      </div>
    </template>
  </Dropdown>
</template>
<script setup lang="ts">
import { can, CustimooOrderFlowStatuses } from "@/composables";
import {
  handleResponseException,
  http,
} from "@/interceptors/axiosRequestInterceptor";
import { DashboardRequest } from "@/models";
import { useMainStore } from "@/store";
import {
  CheckIcon,
  ChevronDownIcon,
  FunnelIcon,
  PlusIcon,
  XMarkIcon,
} from "@heroicons/vue/24/outline";
import { get, isArray } from "lodash";
import { storeToRefs } from "pinia";
import { computed, defineEmits, nextTick, onMounted, ref, watch } from "vue";
import Dropdown from "../Shared/Dropdown.vue";
import Select from "../Shared/Select.vue";

interface CustomFilter {
  key: string;
  label: string;
  type:
    | "string"
    | "single-select"
    | "multi-select"
    | "date"
    | "autocomplete"
    | "date-range";
  value: string | Array<string> | Record<"to" | "from", string>;
  options?: any[];
}

interface Filter {
  key: string;
  label: string;
  value: string | Array<string> | Record<"to" | "from", string>;
}

interface Customer {
  label: string;
  value: number | string | Array<string> | Record<"to" | "from", string>;
}

const emits = defineEmits(["updateFilter"]);
const props = defineProps<{
  currentTab: string;
  currentMode: string;
}>();

const store = useMainStore();
const {
  permissionLoaded,
  orderAdmins,
  merchantUsers,
  dashboardQuickFilters,
  factories,
} = storeToRefs(useMainStore());
const currentDashboardModel = localStorage.getItem("dashboardRequest");
const current_filters = ref<DashboardRequest | undefined>(
  currentDashboardModel
    ? JSON.parse(currentDashboardModel).dashboardRequest
    : undefined,
);
if (current_filters.value && typeof current_filters.value === "string") {
  current_filters.value = JSON.parse(current_filters.value).dashboardRequest;
}

const selectedAllFilter = ref<string[]>([]);
onMounted(async () => {
  await store.getAllMerchants();
});

const selectedFilter = ref<string | null>(null);
const selectedUrgentOrderFilter = ref<string | null>(null);
const filterPresets = ref<Filter[]>([]);
const filterUrgentOrders = ref<Filter[]>([]);
const allFilters = ref<CustomFilter[]>([]);
const customFilter = ref<CustomFilter[]>([]);
const customers = ref<Customer[]>([]);

const computedFilterList = computed(() => {
  if (props.currentMode === "calendar") {
    return allFilters.value.filter(
      (filter) =>
        filter.key === "customers" ||
        filter.key === "merchants" ||
        filter.key === "factory_ids" ||
        filter.key === "order_admins",
    );
  }
  // In other modes, exclude already selected filters
  return allFilters.value.filter(
    (filter) => !customFilter.value.find((f) => f.key === filter.key),
  );
});

// Utility to build the quick_filters object from customFilter
function buildQuickFiltersObj(customFilterArr) {
  const quickFiltersObj = {};
  customFilterArr.forEach((f) => {
    if (Array.isArray(f.value) && f.value.length > 0) {
      // For multi-select and autocomplete, always send only the array of values
      quickFiltersObj[f.key] = f.value.map((v) =>
        typeof v === "object" && v !== null && "value" in v ? v.value : v,
      );
    } else if (
      typeof f.value === "object" &&
      f.value !== null &&
      "to" in f.value &&
      "from" in f.value &&
      f.value.to &&
      f.value.from
    ) {
      quickFiltersObj[f.key] = f.value;
    } else if (f.value !== null && f.value !== undefined && f.value !== "") {
      quickFiltersObj[f.key] = f.value;
    }
  });
  return quickFiltersObj;
}

const getQuickFilterData = async (filter) => {
  selectedFilter.value =
    typeof filter === "object" && filter !== null && "value" in filter
      ? filter.value
      : filter;
  // Always emit, even if custom filters are present
  const quickFiltersObj = buildQuickFiltersObj(customFilter.value);
  emits("updateFilter", {
    items_for: selectedFilter.value || "all_items",
    quick_filters: quickFiltersObj,
  });
}

const getUrgentOrderFilters = async (filter: string) => {
  // Create filter object maintaining existing filters
  selectedUrgentOrderFilter.value = filter;
  const filterData = {
    items_for: selectedFilter.value,// Preserve existing filters
    urgent_orders: filter,
  };
  dashboardQuickFilters.value = filterData;
  emits("updateFilter", filterData);

};

const clearFilters = async () => {
  selectedFilter.value = null;
  selectedUrgentOrderFilter.value = null;
  dashboardQuickFilters.value = null;
  customFilter.value = [];
  const filterData = {
    items_for: 'all_items',// Preserve existing filters
    urgent_orders: null,
  };
  emits("updateFilter", filterData);

};
const addFilter = (filter: CustomFilter): void => {
  selectedAllFilter.value = [
    ...selectedAllFilter.value,
    JSON.parse(JSON.stringify(filter.label)),
  ];
  customFilter.value = [
    ...customFilter.value,
    JSON.parse(JSON.stringify(filter)),
  ];
};
const removeFilter = async (index: number): Promise<void> => {
  selectedAllFilter.value = selectedAllFilter.value.filter(
    (_, i) => i !== index,
  );
  customFilter.value = customFilter.value.filter((_, i) => i !== index);
  await nextTick();
};
const getFilterPresets = (): Filter[] => {
  if (props.currentMode === "calendar") {
    return [
      can("show-my-assign-orders") && {
        label: "My Assigned Orders",
        value: "my_assigned_orders",
        key: "items_for",
      },
    ].filter(Boolean);
  }

  const presets: Filter[] = [
    can("can-resolve-comment") && {
      label: "Unresolved Comments",
      value: "unresolved_comments",
      key: "items_for",
    },
    {
      label: "Reorders",
      value: "reorders",
      key: "items_for",
    },
    {
      label: `<p>Awaiting Customer Feedback</p>`,
      value: "customer_await_items",
      key: "items_for",
    },
    {
      label: `<p>No Order Admin Assigned</p>`,
      value: "no_order_admin",
      key: "items_for",
    },
    {
      label: `<p>Awaiting Factory Actions</p>`,
      value: "pending_items",
      key: "items_for",
    },
    can("view-samples") && {
      label: `<p>Samples</p>`,
      value: "samples",
      key: "items_for",
    },
    {
      label: `<p>Quote Requested</p>`,
      value: "quote_requested_items",
      key: "items_for",

    },
    {
      label: `<p>Open</p>`,
      value: "open_orders",
      key: "items_for",
    },
  ].filter((item) => typeof item !== "boolean");

  return presets;
};

const getFilterUrgentOrders = (): Filter[] => {
  return [
    {
      label: `<p class="flex flex-row justify-between items-center gap-x-4"> <span>Extra Attention</span> <span class="rounded-full bg-blue-300 px-[10px] py-[10px]"></span></p>`,
      value: "extra_attention",
      key: "urgent_orders",
    },
    {
      label: `<p class="flex flex-row justify-between items-center gap-x-4"> <span>Urgent</span> <span class="rounded-full order_cancel px-[10px] py-[10px]"></span></p>`,
      value: "urgent",
      key: "urgent_orders",
    },
    {
      label: `<p class="flex flex-row justify-between items-center gap-x-4"> <span>VIP</span> <span class="rounded-full bg-green-300 px-[10px] py-[10px]"></span></p>`,
      value: "vip",
      key: "urgent_orders",
    },
  ].filter((item) => typeof item !== "boolean");
};



const getAllFilters = (): CustomFilter[] => {
  const filters: CustomFilter[] = [
    {
      key: "status",
      label: "Status",
      type: "multi-select",
      value: "",
      options: Object.keys(CustimooOrderFlowStatuses).map((key) => ({
        label: CustimooOrderFlowStatuses[key],
        value: key,
      })),
    },
    {
      key: "created_at",
      label: "Order Creation",
      type: "date-range",
      value: {
        to: "",
        from: "",
      },
    },
    ...(can("order_administrator_list")
      ? [
          {
            key: "order_admins",
            label: "Order Admins",
            type: "multi-select" as const,
            value: "",
            options: orderAdmins.value.map((admin) => ({
              label: admin.name,
              value: admin.id,
            })),
          },
        ]
      : []),
    {
      key: "customers",
      label: "Customer",
      type: "autocomplete",
      value: [],
      options: customers.value.map((customer) => ({
        label: customer.label,
        value: customer.value,
      })),
    },
    ...(can("merchants_list")
      ? [
          {
            key: "merchants",
            label: "Merchant",
            type: "multi-select" as const,
            value: "",
            options: merchantUsers.value.map((merchant) => ({
              label: merchant.company_name,
              value: merchant.id,
            })),
          },
        ]
      : []),
  ];

  if (
    props.currentMode === "calendar" &&
    factories.value.length > 0 &&
    can("show-factory-filter")
  ) {
    filters.push({
      key: "factory_ids",
      label: "Factory",
      type: "multi-select",
      value: [],
      options: factories.value.map((factory) => ({
        label: factory.name,
        value: factory.id,
      })),
    });
  }

  return filters;
};

watch(
  [
    () => permissionLoaded.value,
    () => props.currentTab,
    () => merchantUsers.value,
    () => orderAdmins.value,
    () => props.currentMode,
  ],
  (newVal) => {
    if (newVal) {
      filterPresets.value = getFilterPresets();
      filterUrgentOrders.value = getFilterUrgentOrders();
      if (
        current_filters.value &&
        filterPresets.value.some(
          (filter: Filter) =>
            filter.value ===
            (current_filters.value ? current_filters.value.items_for : ""),
        )
      ) {
        selectedFilter.value = current_filters.value.items_for;
      }
      allFilters.value = getAllFilters();
    }
  },
  { deep: true },
);

const fetchCustomers = async (query: string): Promise<boolean> => {
  if (!query || query.length < 3) {
    customers.value = [];
    return true;
  }

  try {
    const resp = await http.post(`/search-customers`, { query });
    const autoCompleteFilter = customFilter.value.find(
      (filter) => filter.key === "customers",
    );
    if (autoCompleteFilter) {
      autoCompleteFilter.options = [
        ...resp.data.result.map((customer: any) => ({
          label: `${customer.full_name}`,
          value: `${customer.email}`,
        })),
      ];
    }
    return true;
  } catch (e: any) {
    handleResponseException(e);
    return true;
  }
};

watch(
  customFilter,
  (newFilters) => {
    const quickFiltersObj = buildQuickFiltersObj(newFilters);
    emits("updateFilter", {
      items_for:
        typeof selectedFilter.value === "string" && selectedFilter.value
          ? selectedFilter.value
          : "all_items",
      quick_filters: quickFiltersObj,
    });

  },
  { deep: true },
);
</script>
<style lang="scss" scoped>
label {
  &:has(input[type="radio"]:checked) {
    background: #eaebee;
    svg {
      background: #00b0877e;
      border-color: #00b0877e;
      path {
        fill: white;
      }
    }
  }
  user-select: none;
}
</style>
